import { BaseInput, BaseInputConstructor } from './base-input';

export type TextInputType =
	| 'email'
	| 'number'
	| 'password'
	| 'search'
	| 'tel'
	| 'text'
	| 'url';

export interface TextInputConstructor extends BaseInputConstructor {
	type: TextInputType;
}

/**
 * @param autocomplete {string} tipologia controllo form
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete#values
 * @since 17.0.4
 */
export class TextInput extends BaseInput {
	inputType = 'textbox';
	type: TextInputType;

	constructor(
		options: TextInputConstructor,
		readonly autocomplete: string = 'off'
	) {
		super(options);
		this.type = options.type;
		this.autocomplete = autocomplete;
	}
}
